import { useTranslation } from 'react-i18next';
import type { ILawPartProps } from './ILawPartProps';
import { groupsInOrder, lawValue } from './lawGroups';
import { normTone } from './lawTones';

/**
 * «Структура закону» (прототип v4 lawSecs): розділи в порядку статей (без розділу — «—»), у кожному — статті з лівою смугою кольору
 * норми: «Ст. N · Норма», назва, «хто → щодо кого» (і в підказці).
 */
export function LawSections({ arts, labels, onOpen }: ILawPartProps) {
  const { t } = useTranslation();
  const subj = (r: (typeof arts)[number]) => [labels.option('ldart', 'subject', r.values['subject']), labels.option('ldart', 'counterparty', r.values['counterparty'])]
    .filter(Boolean).join(' → ');
  return (
    <section className="law-sec">
      <div className="law-sec__title">{t('recordPage.law.structure')}</div>
      <div className="law-secs">
        {groupsInOrder(arts, 'section').map((g) => (
          <div key={g.value} className="law-secs__group">
            <strong>{g.value}</strong>
            {g.items.map((r) => (
              <button key={r.id} type="button" className={`law-art law-t-${normTone(r.values['norm'])}`} title={subj(r)} onClick={() => onOpen('ldart', r)}>
                <span className="law-art__num">{labels.article(r.values['num'])} · {labels.option('ldart', 'norm', lawValue(r, 'norm'))}</span>
                <span className="law-art__title">{r.title}</span>
                <span className="law-art__subj">{subj(r)}</span>
              </button>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
